import { Selector, createSelector } from 'reselect'

import {
  networkGroup,
} from './utils'

import {
  IRecord_CRMTag,
  IRecord_CRMImport_WithJobsAndUser,
  IRecord_CRMContact_WithTags,
  IRecord_CRMContact_WithData,
  IData_CRMEvent_Type_Summary,
  IData_CRMEvent_Group_Summary,
  IRecord_CRMEvent_With_Data,
} from '@kaidam/fc-shared/src/types/schema/crm'

import {
  IData_MagicTag_Summary,
} from '@kaidam/fc-shared/src/types/schema/magic_tag'

import {
  IData_Paginated_Results,
} from '@kaidam/fc-shared/src/types/pagination'

import {
  IElasticSearchResult,
} from '@kaidam/fc-shared/src/types/elasticsearch'

import {
  IElasticSearch_Source_CRM,
  IData_CRM_Summary,
} from '@kaidam/fc-shared/src/types/crm'

import {
  getEventTypeTree,
  getEventTypeTreeSelectOptions,
} from '@kaidam/fc-shared/src/utils/event'

import {
  GenericTag,
} from '../../types/components'

import {
  RootState,
} from '../../types/store'

export const tags: Selector<RootState, IRecord_CRMTag[]> = state => 
  state.crm.tags

export const imports: Selector<RootState, IRecord_CRMImport_WithJobsAndUser[]> = state => 
  state.crm.imports

export const searchResults: Selector<RootState, IElasticSearchResult<IElasticSearch_Source_CRM>[]> = state =>
  state.crm.searchResults

export const eventTypes: Selector<RootState, IData_CRMEvent_Type_Summary[]> = state => state.crm.eventTypes
export const eventGroups: Selector<RootState, IData_CRMEvent_Group_Summary[]> = state => state.crm.eventGroups
export const eventData: Selector<RootState, IRecord_CRMEvent_With_Data[]> = state => state.crm.eventData
export const eventPagination: Selector<RootState, IData_Paginated_Results> = state => state.crm.eventPagination

export const contactData: Selector<RootState, IRecord_CRMContact_WithTags[]> = state => state.crm.contactData
export const contactPagination: Selector<RootState, IData_Paginated_Results> = state => state.crm.contactPagination
export const contactDetail: Selector<RootState, IRecord_CRMContact_WithData | null> = state => state.crm.contactDetail
export const magicTags: Selector<RootState, IData_MagicTag_Summary[]> = state => state.crm.magicTags
export const querySummary: Selector<RootState, IData_CRM_Summary[]> = state => state.crm.querySummary

export const network = networkGroup('crm', [
  'listTags',
  'tagForm',
  'deleteTag',
  'loadEvents',
  'loadContacts',
  'listImports',
  'getContact',
  'search',
  'contactForm',
  'deleteContact',
  'eventForm',
  'deleteEvent',
  'noteForm',
  'deleteNote',
  'loadMagicTags',
])

export const eventTypeTree = createSelector(
  eventTypes,
  (eventTypes) => getEventTypeTree(eventTypes)
)

export const eventTypeTreeSelectOptions = createSelector(
  eventTypes,
  (eventTypes) => getEventTypeTreeSelectOptions(eventTypes)
)

export const eventGroupSelectOptions = createSelector(
  eventGroups,
  (eventGroups) => eventGroups.map(item => {
    return {
      name: `${item.group} (${item.count})`,
      value: item.group,
    }
  })
)

export const tagsById = createSelector(
  tags,
  (tags): Record<string, IRecord_CRMTag> => tags.reduce<Record<string, IRecord_CRMTag>>((all, tag) => {
    all[tag.id] = tag
    return all
  }, {})
)

export const genericTags = createSelector(
  tags,
  (tags): GenericTag[] => {
    const ret = tags.map(tag => {
      return {
        id: tag.id,
        name: tag.name,
        color: tag.meta?.color,
      }
    })
    ret.sort((a, b) => {
      if (a.name.toLowerCase() < b.name.toLowerCase()) return -1
      if (a.name.toLowerCase() > b.name.toLowerCase()) return 1
      return 0
    })
    return ret
  }
)

export default {
  tags,
  imports,
  searchResults,
  network,
  eventTypes,
  eventGroups,
  eventData,
  eventPagination,
  eventTypeTree,
  eventTypeTreeSelectOptions,
  eventGroupSelectOptions,
  contactData,
  contactPagination,
  contactDetail,
  tagsById,
  genericTags,
  magicTags,
  querySummary,
}
